import { render, staticRenderFns } from "./NewsEntity.vue?vue&type=template&id=9b7dd3f4&"
import script from "./NewsEntity.vue?vue&type=script&lang=js&"
export * from "./NewsEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports